import { render, staticRenderFns } from "./DarkSwitch.vue?vue&type=template&id=64d1d908"
import script from "./DarkSwitch.vue?vue&type=script&lang=js"
export * from "./DarkSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports